// FIXME: 使用していない変数を削除する

// 時間選択コンポーネント
// 15分ごとの時間を選択してunixtimeを返す
// 選択時間が更新されたら親のformに値をセットする
import { useContext, useEffect, useState } from 'react'
import { SelectPresenter } from '@/components/Common/components/parts/Select/presenter/SelectForBlockPresenter'
import { ClinicContext, useGraphqlClient } from '@/App'
import { getUnixTime, startOfDay } from 'date-fns'
import { useGetLatestClinicConfigQuery } from '@/_graphql/graphql-client'
import { SetDateContext } from '@/components/Main/provider/MainProvider'
import { emptyClinicTimeConfig } from '@/components/Common/utils/common/emptyData'
import { useCommonParams } from '@/domain/Common/useCommonParams'
import type { ClinicTimeType } from '@/components/Common/entities'

interface SelectViewsType {
    formType: 'appoint' | 'block'
    formData: any // FIXME: BlockFormType | AppointFormTypeを指定する
    setValue: (name: string, value: any) => void
    register: any
    setEndTime: any
    minTreatmentTime: number
    stepsMinutes: number
}

export const SelectViews: React.FC<SelectViewsType> = ({
    formType,
    formData,
    setValue,
    register,
    setEndTime,
    minTreatmentTime,
    stepsMinutes
}) => {
    const registerType = formType === 'appoint' ? 'appointData' : 'block'
    const [selected, setSelected] = useState<number>(formData.endTime);

    const graphqlClient = useGraphqlClient()
    const { startTime, endTime } = useCommonParams()
    const clinic = useContext(ClinicContext)
    const { nowDate } = useContext(SetDateContext)
    const activeClinicTimeConfig = useGetLatestClinicConfigQuery(graphqlClient, { clinic_id: clinic.clinic_id, current_date: getUnixTime(startOfDay(nowDate)), config_type: 'clinic_time' })
    const configData = activeClinicTimeConfig.data?.getLatestClinicConfig?.config ?? null
    const clinicTime = configData !== null && 'clinicTime' in configData && configData.clinicTime !== null && configData.clinicTime !== undefined
        ? configData.clinicTime 
        : emptyClinicTimeConfig.config.clinicTime as ClinicTimeType

    useEffect(() => {
        setValue(`${registerType}.endTime`, Number(selected))
    }, [selected])

    useEffect(() => {
        const endTimeValue = endTime ?? 0
        if (endTimeValue > 0) {
            setSelected(endTimeValue)
        }
    }, [startTime])

    return (
        <SelectPresenter
            setSelected={setSelected}
            registerType={registerType}
            clinic_time={clinicTime}
            register={register}
            treatmentStartTime={startTime ?? 0}
            setEndTime={setEndTime}
            stepsMinutes={stepsMinutes}
            minTreatmentTime={minTreatmentTime}
        />
    )
}


